var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"buttons"},_vm._l((_vm.buttons),function(btn,index){return _c('img',{key:index,staticClass:"action-btn",attrs:{"src":btn.src,"alt":btn.alt},on:{"click":function($event){return _vm.handleButtonClick(btn.type)}}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }